import {
  addDaysToYmd,
  studioTodayYmd,
} from "@/lib/utils/date/studio-clock";

/** Private-lesson conflict window on teacher Availability. */
export function getAvailabilityPrivateLessonsRange(
  now: Date = new Date(),
): {
  startDate: string;
  endDate: string;
} {
  const startDate = studioTodayYmd(now);
  return {
    startDate,
    endDate: addDaysToYmd(startDate, 365),
  };
}
